import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "207",
  height: "207",
  viewBox: "0 0 104 104",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M48 .04A52 52 0 0 0 .07 47.9h7A45 45 0 0 1 47.98 7.07L48 .04ZM48 96.73A45 45 0 0 1 7 54.9H0a52 52 0 0 0 48 48.85v-7.02ZM55 103.81v-7a45 45 0 0 0 41.82-41.89h7A52 52 0 0 1 55 103.81ZM55 7V0a52 52 0 0 1 48.76 47.91h-7A45 45 0 0 0 55 7Z",
  fill: "#D5D4D6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M85 51.5C85 70.001 70.001 85 51.5 85 32.998 85 18 70.001 18 51.5 18 32.998 32.998 18 51.5 18 70.001 18 85 32.998 85 51.5Z",
  fill: "#29A7F4",
  stroke: "#1C87D9",
  "stroke-width": "6"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M49.763 55.61a5.5 5.5 0 0 1 .407-2.098c.293-.688.836-1.387 1.627-2.098l1.695-1.479c.7-.596 1.242-1.226 1.627-1.891.384-.665.576-1.444.576-2.338 0-1.032-.328-1.846-.983-2.442-.656-.619-1.548-.928-2.678-.928-1.198 0-2.158.355-2.881 1.066-.724.687-1.085 1.662-1.085 2.923 0 .55.068 1.146.203 1.788l-4.068-.413A9.631 9.631 0 0 1 44 45.774c0-2.04.712-3.68 2.136-4.917C47.559 39.619 49.548 39 52.102 39c2.486 0 4.418.562 5.796 1.685C59.3 41.808 60 43.402 60 45.465a6.502 6.502 0 0 1-.881 3.267 11.237 11.237 0 0 1-2.305 2.82l-1.628 1.444c-.52.458-.892.928-1.118 1.41-.204.458-.305 1.043-.305 1.754v.997h-4v-1.548Zm-.271 3.988h4.61V64h-4.61v-4.402Z",
  fill: "#fff"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }